/**
 * Type definitions using Base.d.ts
 * @typedef {import('@/types/Base').CouponState} CouponState
 * @typedef {import('@/types/Base').PlanItemBean} PlanItemBean
 * @typedef {import('@/types/Base').SingleAmountPlansMapBean} SingleAmountPlansMapBean
 * @typedef {import('@/types/Base').CouponDiscountMapResultBean} CouponDiscountMapResultBean
 * @typedef {import('@/types/Base').SelectedPlansAmount} SelectedPlansAmount
 * @typedef {import('@/types/Base').NextBillAmount} NextBillAmount
 */
import store from '@/store';
import { DiscountCalculationService } from './discount-calculation-service';

/**
 * Calculate discount based on coupon type with caching
 * @returns {CouponDiscountMapResultBean} Discount result based on coupon type
 */
export const computeDiscountWithAmountMap = () => {
  const {
    couponState = {},
    verifyCouponStatus,
    getSelectedPlans = [],
    getSelectedPlansAmount = {}
  } = store.getters;

  const planWithAmountMap = getSelectedPlansAmount?.plans || {};

  // Calculate discount using service
  return DiscountCalculationService.calculateCouponDiscount(
    couponState,
    getSelectedPlans,
    planWithAmountMap,
    verifyCouponStatus,
    store.getters
  );
};

/**
 * Compute discount info map for all promotion types (legacy wrapper)
 * @param {Object} promotionInfo - Promotion information object
 * @returns {Object} Discount info map for each promotion type
 */
export const computePromotionDiscountInfoMap = (promotionInfo = {}) => {
  const { getSelectedPlans = [], getSelectedPlansAmount = {} } = store.getters;
  return DiscountCalculationService.computePromotionDiscountInfoMap(
    promotionInfo,
    getSelectedPlans,
    getSelectedPlansAmount.plans || {}
  );
};

/**
 * Calculate the next bill amount for each billing cycle after applying all discounts (legacy wrapper)
 * @returns {NextBillAmount} Object containing discount and charge details for each billing cycle
 */
export const computedNextBillAmount = () => {
  const {
    getSelectedPlansAmount = {},
    promotionDiscountInfoMap = {},
    discountWithAmountMap = {},
    getSelectedPlans = [],
    couponState = {}
  } = store.getters;

  return DiscountCalculationService.calculateNextBillAmount(
    getSelectedPlansAmount,
    promotionDiscountInfoMap,
    discountWithAmountMap,
    getSelectedPlans,
    couponState
  );
};
